import React from 'react'

function ManOrgEvCon() {
  return (
    <div></div>
  )
}

export default ManOrgEvCon